<template>
    <div class="w-auto">
        <vue-range-slider
            v-model="sliderVal"
            :min="min"
            :max="max"
            :width="width"
            :step="step"
            :dot-size="dotSize"
            :tooltip-merge="tooltipMerge"
            :enable-cross="enableCross"
            :tooltip-style="setColor"
            :process-style="setColor"
            :formatter="formatter"
            :disabled="disabled"
            @slide-end="slideEnd"
        />
        <div class="range-txt flex justify-between">
            <span :key="key" v-for="(text, key) in getRangeText" class="shadow-text-none font-size-12">{{text}}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default: 0
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 10
        },
        step: {
            type: Number,
            default: 1
        },
        dotSize: {
            type: Number,
            default: 16
        },
        width: {
            type: String,
            default: '100%'
        },
        color: {
            type: String,
            default: '#3498db'
        },
        rangeText: {
            type: Array,
            default: () => []
        },
        formatter: {
            type: Function
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        value (val) {
            if (!val && Array.isArray(val)) {
                val = [0, this.max]
            }
            this.setValue(val);
        }
    },

    computed: {
        setColor () {
            return {
                backgroundColor: this.color,
                borderColor: this.color,
            }
        },
        getRangeText () {
            if (this.rangeText.length <= 0) {
                return [this.min, this.max]
            }

            return this.rangeText
        },
    },

    created () {
        this.setValue(this.value);
    },

    data() {
        return {
            sliderVal: 0,
            enableCross: false,
            tooltipMerge: false
        }
    },

    methods: {
        setValue (value) {
            this.sliderVal = value
        },

        slideEnd (value) {
            this.$emit('change', value)
        }
    }
}
</script>

<style scoped>
    .range-txt span:first-child {
        padding-left: 8px;
    }

    .range-txt span:last-child {
        padding-right: 8px;
    }
</style>
